import React from "react";
import { dsnCN } from "../../hooks/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleUp } from "@fortawesome/free-solid-svg-icons";
function Copyright({ className, ...restProps }) {

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <div className={dsnCN("copyright", className)} {...restProps}>
      <div className="text-center">
        <p>©{new Date().getFullYear()} Devlift A Creative Digital Agency</p>
        <div className="copyright-text over-hidden">
          <a href="/">All right Reserved</a>
        </div>
      </div>
      {/* adding right button scroll to  top */}
      <div className="scroll-to-top">
        <button onClick={scrollTop}>
        <FontAwesomeIcon icon={faArrowCircleUp} size="3x" />
        </button>
        </div>
    </div>
  );
}

export default Copyright;
